import { type TileLayer, FeatureLayer, type Graphic } from './esri-core';

export class LayerDecorator {
  private _layerVisibility = false;
  private _labelVisibility = false;
  private _mapLayer: TileLayer | FeatureLayer;

  constructor(public layerName: string) {}

  get visibility() {
    return this._layerVisibility;
  }

  set visibility(value) {
    this._layerVisibility = value;
    if (this._mapLayer) {
      this._mapLayer.visible = value;
    }
  }

  get labelVisibility() {
    return this._labelVisibility;
  }

  set labelVisibility(value) {
    this._labelVisibility = value;
    if (this._mapLayer && this._mapLayer instanceof FeatureLayer) {
      this._mapLayer.labelsVisible = value;
    }
  }

  get element() {
    return this._mapLayer;
  }

  set element(value) {
    this._mapLayer = value;
    this._mapLayer.visible = this._layerVisibility;
  }
}

export class GraphicDecorator {
  private _graphic: Graphic;

  constructor(public layerName: string) {}

  get visibility() {
    return this._graphic?.visible;
  }

  set visibility(value) {
    if (this._graphic) {
      this._graphic.visible = value;
    }
  }

  readonly labelVisibility = false;

  get element() {
    return this._graphic;
  }

  set element(value) {
    this._graphic = value;
  }
}
